import { render } from "./AddToCartButton.vue?vue&type=template&id=13d9d108&ts=true"
import script from "./AddToCartButton.vue?vue&type=script&lang=ts"
export * from "./AddToCartButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__